import api from './index';

let exports = {};
//
// 工程师休息时间（安排）-分页查询
exports.getEngiDayOffPageList = function (data, callback) {
    api.post('/perform/engi/day/off/page/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 工程师休息时间（安排）-查询
exports.getEngiDayOffList = function (data, callback) {
    api.post('/perform/engi/day/off/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 工程师休息时间（安排）- 保存
exports.saveEngiDayOff = function (data, callback) {
    api.post('/perform/engi/day/off/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 工程师休息时间（安排）- 查询根据id
exports.getEngiDayOffById = function (data, callback) {
    api.get('/perform/engi/day/off/get')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 工程师休息时间（安排）- 修改
exports.updateEngiDayOff = function (data, callback) {
    api.post('/perform/engi/day/off/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 工程师休息时间（安排）- 删除
exports.deleteEngiDayOff = function (data, callback) {
    api.post('/perform/engi/day/off/delete/do')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 工程师出勤绩效-分页查询
exports.getEngiAttendPerformList = function (data, callback) {
    api.post('/perform/engi/attend/perform/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 工程师出勤绩效 - 保存
exports.saveEngiAttendPerform = function (data, callback) {
    api.post('/perform/engi/attend/perform/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/perform.js
// module id = 76
// module chunks = 1